/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Muscles_No_PlanInputs */

const en_us2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without an active plan there is no target to compare with.`)
};

const pt_br2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem um plano ativo, não há meta para comparar.`)
};

const es_419_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin un plan activo, no hay meta con la cual comparar.`)
};

const pt_pt2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem um plano ativo, não há meta para comparar.`)
};

const fr_fr2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans programme actif, il n'y a pas d'objectif à comparer.`)
};

const de_de2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne aktiven Plan gibt es kein Ziel zum Vergleich.`)
};

const it_it2_progress_report_muscles_no_plan = /** @type {(inputs: Progress_Report_Muscles_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza una scheda attiva non c'è un obiettivo con cui confrontare.`)
};

/**
* | output |
* | --- |
* | "Without an active plan there is no target to compare with." |
*
* @param {Progress_Report_Muscles_No_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_muscles_no_plan = /** @type {((inputs?: Progress_Report_Muscles_No_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Muscles_No_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_muscles_no_plan(inputs)
	if (locale === "es-419") return es_419_progress_report_muscles_no_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_muscles_no_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_muscles_no_plan(inputs)
	if (locale === "de-DE") return de_de2_progress_report_muscles_no_plan(inputs)
	if (locale === "it-IT") return it_it2_progress_report_muscles_no_plan(inputs)
	return en_us2_progress_report_muscles_no_plan(inputs)
});
export { progress_report_muscles_no_plan as "progress-report.muscles_no_plan" }